<template>
    <v-container fluid>
        <div class="modal-padding">
            <v-row>
                <!-- <v-col cols="12" sm="12">
                    <div class="instructions-title">Instructions</div>
                </v-col> -->
                <v-col cols="12" sm="12" class="zero-top test-view">
                    <v-card class="mx-auto normal-card instructions-hg">
                        <!-- <CommonInstructionsContent /> -->

                        <div class="inst-title inst-about-test">Instructions about the test.</div>
                        <div v-html="data.selectedTest.instructions"></div>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12">
                    <div class="right-align">
                        <v-btn @click="onClose({status:false})" class="right-btn cust-btn" color="primary">Done</v-btn>
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>
<script>
import CommonInstructionsContent from "@/components/student/Tests/CommonInstructionsContent.vue";

export default {
    components: {
        CommonInstructionsContent
    },
    name: 'HintOne',
    props: ['onClose', 'status','data'],
    data() {
        return {
        }
    },   
    mounted()
    {
        this.renderMath();
    }
}
</script>
